import { useSEO } from '@/hooks/useSEO';
import PageNavbar from "@/components/feature/PageNavbar";
import AboutHero from "./components/AboutHero";
import AboutProfile from "./components/AboutProfile";
import AboutMission from "./components/AboutMission";
import AboutFormula from "./components/AboutFormula";
import Footer from "@/pages/home/components/Footer";

const SITE_URL = (import.meta.env.VITE_SITE_URL as string) || 'https://isman.co.ke';

const ABOUT_SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "About ISMAN Engineering Company",
    "url": SITE_URL + "/about",
    "description": "Learn about ISMAN Engineering Company — over 15 years of industrial engineering experience in Nairobi, Kenya. Expert team of mechanical, electrical and electronics engineers.",
    "mainEntity": {
      "@type": "Organization",
      "name": "ISMAN Engineering Company",
      "url": SITE_URL,
      "telephone": "+254724114555",
      "email": "info@isman.co.ke",
      "foundingDate": "2009",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Nairobi",
        "addressCountry": "KE"
      },
      "areaServed": { "@type": "Country", "name": "Kenya" }
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": SITE_URL },
      { "@type": "ListItem", "position": 2, "name": "About", "item": SITE_URL + "/about" }
    ]
  }
];

export default function AboutPage() {
  useSEO({
    title: 'About ISMAN Engineering | 15+ Years Industrial Engineering Nairobi Kenya',
    description: 'ISMAN Engineering Company — a team of highly skilled engineers with 15+ years hands-on experience in industrial equipment, HVAC, food processing and automation in Nairobi, Kenya.',
    keywords: 'about ISMAN engineering Nairobi, industrial engineers Kenya, engineering company Nairobi Kenya',
    canonical: SITE_URL + '/about',
    schema: ABOUT_SCHEMA,
  });

  return (
    <div className="min-h-screen bg-white">
      <PageNavbar />
      <main className="pt-8">
        <AboutHero />
        <AboutProfile />
        <AboutMission />
        <AboutFormula />
        <section className="py-14 px-6 bg-slate-900">
          <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="text-white text-2xl font-extrabold">Download our Company Profile</h3>
              <p className="text-white/60 text-sm mt-1">Full profile and services brochure — print-ready A4 PDFs.</p>
            </div>
            <div className="flex flex-wrap gap-3">
              <a href="/downloads/ISMAN-Company-Profile.pdf" download className="bg-teal-600 hover:bg-teal-500 text-white font-bold px-5 py-3 rounded-lg text-sm flex items-center gap-2"><i className="ri-file-download-line"></i> Company Profile</a>
              <a href="/downloads/ISMAN-Services-Brochure.pdf" download className="border-2 border-white/40 hover:border-teal-300 text-white font-bold px-5 py-3 rounded-lg text-sm flex items-center gap-2"><i className="ri-book-open-line"></i> Services Brochure</a>
              <a href="/company-profile" className="text-teal-300 hover:text-teal-200 font-semibold px-2 py-3 text-sm flex items-center gap-1">View online <i className="ri-arrow-right-line"></i></a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
